export default __webpack_public_path__ + "static/media/foodvaluechain.11777826.jpg";